(() => {
  'use strict';
  const data = document.getElementById('mhe-prueba-variants');
  if (!data || window.mhePruebaReady) return;
  window.mhePruebaReady = true;
  const variants = JSON.parse(data.textContent);
  const money = n => '$' + Math.round(n / 100).toLocaleString('es-CL');
  const sizeKey = s => String(s).replace(/\s/g, '').replace('×', 'x');
  const MAX_PARTICIPANTS = 12;
  const ideas = {'18x23':['Pequeño y cercano','Velador, escritorio o repisa. Un recuerdo para mirar de cerca.'], '27x33':['Un rincón con historia','Escritorio, aparador o una composición de cuadros.'], '28x38':['Un detalle con presencia','Dormitorio, recibidor o una pareja de cuadros en el pasillo.'], '43x53':['Un punto de atención','Sobre un arrimo, escritorio o aparador; también en una pared de paso.'], '55x75':['Dale protagonismo','Sobre una cama, aparador o sofá pequeño, según el espacio disponible.'], '75x105':['Una mirada que llena el espacio','Una pared amplia del living o dormitorio, como pieza protagonista.']};
  const visible = el => Boolean(el && el.getClientRects().length && getComputedStyle(el).display !== 'none');
  let root, status, total, lastSize = '', busy = false, queued = false, lastPets=1, lastPeople=0;
  const subjects = () => [...root.querySelectorAll('.mhe-subject')];
  const subjectInfo = group => {
    const match=group.className.match(/mhe-(pet|human)-(\d+)/);
    return match ? {kind:match[1],number:Number(match[2])} : null;
  };
  const hasPhoto = group => Boolean(group.querySelector('.apo_value')?.value || group.querySelector('input[type=file]')?.files?.length);
  const uploadNow = () => root.querySelector('input[type=radio][value="Subir fotos ahora"]')?.checked;
  function references(p,h){
    for(const group of subjects()){
      const info=subjectInfo(group);if(!info)continue;
      const active=Boolean(uploadNow() && info.number<=(info.kind==='pet'?p:h));
      group.dataset.active=String(active);
      const error=group.querySelector('.mhe-photo-error');
      if(error && (!active || group.querySelector('.apo_value')?.value))error.remove();
      if(info.number>(info.kind==='pet'?p:h)){
        const name=group.querySelector('input[type=text]');if(name?.value)set(name,'');
      }
      group.style.order=String((info.kind==='pet'?100:120)+info.number);
      const heading=group.querySelector('.apo-option-group');
      if(heading){heading.setAttribute('role','button');heading.setAttribute('tabindex','0');heading.setAttribute('aria-label',(info.kind==='pet'?'Mascota ':'Persona ')+info.number+': foto y nombre opcional');}
      const action=group.querySelector('.apo-file__action');
      if(action && action.textContent==='Elegir Archivo')action.textContent='Subir foto';
    }
    const trust=root.querySelector('.mhe-promise')?.closest('.avp-option');if(trust)trust.style.order='200';
    if(total)total.style.order='201';
  }
  function validateReferences(){
    if(!root||!uploadNow())return true;
    const missing=subjects().find(g=>g.dataset.active==='true'&&!g.querySelector('.apo_value')?.value);
    if(!missing)return true;
    const heading=missing.querySelector('.apo-option-group');
    const child=missing.querySelector('.apo-group-child');
    if(child&&!visible(child))heading?.click();
    missing.classList.add('mhe-photo-missing');
    let error=missing.querySelector('.mhe-photo-error');
    if(!error){error=document.createElement('p');error.className='mhe-photo-error';error.setAttribute('role','alert');missing.append(error);}
    error.textContent='Sube su foto y espera a que termine de cargar, o elige enviarla después por WhatsApp.';
    missing.scrollIntoView({behavior:'smooth',block:'center'});heading?.focus();return false;
  }
  const current = () => {
    const choice = document.querySelector('.avis-swatch-view input[type="radio"]:checked') || document.querySelector('input[id^="avis-option-value-item-"]:checked');
    const selected = choice && variants.find(v => sizeKey(v.option1) === sizeKey(choice.value));
    const id = new URL(location.href).searchParams.get('variant');
    return selected || variants.find(v => String(v.id) === id) || variants[0];
  };
  const fields = () => ({pets:[...root.querySelectorAll('input.avp-quantity-input')].find(e => /^Mascotas/.test(e.name) && visible(e.closest('.avp-option'))), people:root.querySelector('input[name="Personas"]')});
  const set = (el, value) => {
    if (String(value) === el.value) return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(el, String(value));
    el.dispatchEvent(new Event('input', {bubbles:true}));
    el.dispatchEvent(new Event('change', {bubbles:true}));
  };
  function refresh(changed) {
    if (busy || !root?.isConnected) return;
    const {pets, people} = fields();
    if (!pets || !people) return;
    busy = true;
    const variant = current(), key = sizeKey(variant.option1), cap = MAX_PARTICIPANTS;
    let p = Math.max(1, Math.min(cap, Math.floor(Number(pets.value) || 1)));
    let h = Math.max(0, Math.min(cap - 1, Math.floor(Number(people.value) || 0)));
    const sizeChanged = key !== lastSize;
    if(lastSize && sizeChanged){p=lastPets;h=lastPeople;}
    if (p + h > cap) {
      if (changed === pets && !sizeChanged) p = Math.max(1, cap - h);
      else h = Math.max(0, cap - p);
    }
    let protectedPhoto='';
    for(const group of subjects()){
      const info=subjectInfo(group);if(!info)continue;
      const count=info.kind==='pet'?p:h;
      if(info.number>count && hasPhoto(group)){
        if(info.kind==='pet')p=Math.max(p,info.number);else h=Math.max(h,info.number);
        protectedPhoto='Quita primero la foto de '+(info.kind==='pet'?'Mascota ':'Persona ')+info.number+' para reducir la cantidad.';
      }
    }
    if(p+h>cap){if(changed===pets)p=cap-h;else h=cap-p;}
    const adjusted = String(p) !== pets.value || String(h) !== people.value;
    set(pets,p); set(people,h);
    pets.min = '1'; pets.max = String(cap - h);
    people.min = '0'; people.max = String(cap - p);
    for (const el of [pets,people]) {
      const wrap = el.closest('.avp-quantity-control-wrapper');
      for(const [selector,disabled,label] of [['.avp-quantity-control-minus',Number(el.value)<=Number(el.min),'Quitar'],['.avp-quantity-control-plus',Number(el.value)>=Number(el.max),'Añadir']]) {
        const button=wrap?.querySelector(selector);
        if(button){button.setAttribute('role','button');button.setAttribute('tabindex','0');button.setAttribute('aria-label',label+' '+(el===pets?'mascota':'persona'));button.setAttribute('aria-disabled',String(disabled));}
      }
    }
    const help = pets.closest('.avp-option').querySelector('.ap-helptext');
    const helpText = '$3.990 cada mascota adicional';
    if(help && help.textContent!==helpText)help.textContent=helpText;
    const message = protectedPhoto || (adjusted ? 'Máximo 12 mascotas y personas en total.' : '');
    if(status.textContent!==message)status.textContent=message;
    const gift = root.querySelector('.mhe-gift input[type="checkbox"]:checked') ? 399000 : 0;
    const amount = variant.price + (p+h-1)*399000 + gift;
    const totalText = `Total de tu retrato: ${money(amount)}`;
    if(total.textContent!==totalText)total.textContent=totalText;
    references(p,h);
    lastSize=key;lastPets=p;lastPeople=h;busy=false;
  }
  function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;init();refresh();});}
  const dialog=document.createElement('dialog');
  dialog.className='mhe-size-dialog';dialog.setAttribute('aria-labelledby','mhe-size-title');
  const sizes=[...new Set(variants.map(v=>sizeKey(v.option1)))].filter(k=>ideas[k]);
  dialog.innerHTML=`<button type="button" class="mhe-size-close" aria-label="Cerrar guía de tamaños">×</button><p class="mhe-size-eyebrow">SU RETRATO, EN TU HOGAR</p><h2 id="mhe-size-title">Encuentra su lugar especial</h2><p class="mhe-size-intro">Un detalle en tu velador o el protagonista de tu living. Elige cuánto espacio quieres darle a ese amor.</p><div class="mhe-size-note"><strong>Medidas exteriores, marco incluido</strong><p>Ancho × alto, de borde exterior a borde exterior del cuadro enmarcado. No son las medidas de la lámina ni de la imagen visible.</p></div><div class="mhe-size-scale" aria-label="Comparación proporcional de los formatos"><div class="mhe-size-shapes">${sizes.map(k=>{const [w,h]=k.split('x').map(Number);return `<div class="mhe-size-shape-item"><span class="mhe-size-shape" style="width:${w*.9}px;height:${h*.9}px" aria-hidden="true"></span><small>${w}×${h}</small></div>`;}).join('')}</div><p>Proporciones de referencia entre formatos.</p></div><table class="mhe-size-table"><caption>Qué tamaño elegir para cada espacio</caption><thead><tr><th scope="col">Cuadro enmarcado</th><th scope="col">Una idea para tu hogar</th></tr></thead><tbody>${sizes.map(k=>`<tr><th scope="row">${k.replace('x',' × ')} cm</th><td><strong>${ideas[k][0]}</strong><p>${ideas[k][1]}</p></td></tr>`).join('')}</tbody></table><div class="mhe-size-tip"><strong>Pruébalo antes de elegir</strong><p>Recorta un papel con las medidas exteriores y ubícalo donde irá el retrato. Míralo desde la entrada de la habitación y junto a tus muebles.</p></div><p class="mhe-size-foot">Siempre al menos 1 mascota. Las personas pueden acompañarla. Revisa los acabados disponibles en el selector de tu retrato.</p>`;
  document.body.append(dialog);
  dialog.querySelector('button').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
  document.addEventListener('click',e=>{
    const guide=e.target.closest('.ap-options__size_chart-container');
    if(guide&&root?.contains(guide)){e.preventDefault();e.stopImmediatePropagation();dialog.showModal();return;}
    const control=e.target.closest('.avp-quantity-control');
    if(control&&root?.contains(control)){
      const input=control.parentElement.querySelector('input');
      const delta=control.matches('.avp-quantity-control-plus')?1:-1;
      if(Number(input.value)+delta<Number(input.min)||Number(input.value)+delta>Number(input.max)){e.preventDefault();e.stopImmediatePropagation();refresh(input);}
      else schedule();
    }
    if(e.target.closest('[id^="ProductSubmitButton-"]')){refresh();if(!validateReferences()){e.preventDefault();e.stopImmediatePropagation();}}
  },true);
  document.addEventListener('keydown',e=>{const control=e.target.closest('.avp-quantity-control');if(control&&root?.contains(control)&&['Enter',' '].includes(e.key)){e.preventDefault();control.click();}});
  document.addEventListener('input',e=>{if(root?.contains(e.target)&&e.target.matches('.avp-quantity-input'))refresh(e.target);});
  document.addEventListener('change',e=>{if(root?.contains(e.target)&&e.target.matches('.avp-quantity-input'))refresh(e.target);else schedule();});
  document.addEventListener('submit',e=>{if(e.target.action?.includes('/cart/add')){refresh();if(!validateReferences()){e.preventDefault();e.stopImmediatePropagation();}}},true);
  document.addEventListener('keydown',e=>{if(e.target.matches('.mhe-subject .apo-option-group')&&['Enter',' '].includes(e.key)){e.preventDefault();e.target.click();}});
  function init(){
    const info=document.querySelector('[id^="ProductInfo-"]');
    if(info){
      const tax=info.querySelector('.product__tax');
      if(tax && tax.textContent.trim()!=='IVA incluido.')tax.textContent='IVA incluido.';
      for(const p of info.querySelectorAll('p')){
        if(p.textContent.includes('También puedes pagar con Flow.'))p.innerHTML='<strong>3 cuotas sin interés</strong> con VentiPay y Mercado Pago';
        if(p.textContent.includes('3 cuotas sin interés'))p.classList.add('mhe-installments');
      }
      for(const badge of info.querySelectorAll('.price__badge-sale')){
        if(!badge.querySelector('.mhe-offer-hearts')){const hearts=document.createElement('span');hearts.className='mhe-offer-hearts';hearts.setAttribute('aria-hidden','true');hearts.textContent=' ♥';badge.append(hearts);}
      }
    }
    const next=document.querySelector('#avpoptions-container__v2:has(.mhe-included)');
    if(!next)return;
    root=next;
    if(!root.dataset.referencesOrdered && subjects().length===23){
      const anchor=root.querySelector('.mhe-promise')?.closest('.avp-option');
      if(anchor){
        subjects().sort((a,b)=>{const x=subjectInfo(a),y=subjectInfo(b);return (x.kind==='pet'?0:100)+x.number-((y.kind==='pet'?0:100)+y.number);}).forEach(group=>root.insertBefore(group,anchor));
        root.dataset.referencesOrdered='true';
      }
    }
    const people=fields().people;
    if(!people)return;
    root.classList.add('mhe-companion-ready');
    if(!root.querySelector('.mhe-composition-status')){
      status=document.createElement('p');status.className='mhe-composition-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');people.closest('.avp-option').append(status);
      total=document.createElement('p');total.className='mhe-composition-total';total.setAttribute('aria-live','polite');root.append(total);
    }else{status=root.querySelector('.mhe-composition-status');total=root.querySelector('.mhe-composition-total');}
  }
  new MutationObserver(schedule).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  window.addEventListener('popstate',schedule);
  init();refresh();
})();
